
    import './styles.scoped.css';
    export default {
  "flash-with-motion": "awsui_flash-with-motion_1q84n_16ici_13",
  "enter": "awsui_enter_1q84n_16ici_13",
  "flash-body": "awsui_flash-body_1q84n_16ici_27",
  "flash-message": "awsui_flash-message_1q84n_16ici_27",
  "flash-header": "awsui_flash-header_1q84n_16ici_27",
  "flash-content": "awsui_flash-content_1q84n_16ici_28",
  "action-button-wrapper": "awsui_action-button-wrapper_1q84n_16ici_29",
  "dismiss-button-wrapper": "awsui_dismiss-button-wrapper_1q84n_16ici_30",
  "flash-icon": "awsui_flash-icon_1q84n_16ici_53",
  "entering": "awsui_entering_1q84n_16ici_66",
  "entered": "awsui_entered_1q84n_16ici_87",
  "exiting": "awsui_exiting_1q84n_16ici_192",
  "stack": "awsui_stack_1q84n_16ici_218",
  "animation-running": "awsui_animation-running_1q84n_16ici_218",
  "item": "awsui_item_1q84n_16ici_218",
  "flash-list-item": "awsui_flash-list-item_1q84n_16ici_219",
  "notification-bar": "awsui_notification-bar_1q84n_16ici_220",
  "collapsed": "awsui_collapsed_1q84n_16ici_240",
  "animation-ready": "awsui_animation-ready_1q84n_16ici_240",
  "expanded-only": "awsui_expanded-only_1q84n_16ici_240",
  "expanded": "awsui_expanded_1q84n_16ici_240",
  "flash": "awsui_flash_1q84n_16ici_13",
  "collapsible": "awsui_collapsible_1q84n_16ici_298",
  "short-list": "awsui_short-list_1q84n_16ici_304",
  "visual-refresh": "awsui_visual-refresh_1q84n_16ici_342",
  "status": "awsui_status_1q84n_16ici_418",
  "header": "awsui_header_1q84n_16ici_418",
  "item-count": "awsui_item-count_1q84n_16ici_419",
  "button": "awsui_button_1q84n_16ici_420",
  "type-count": "awsui_type-count_1q84n_16ici_453",
  "count-number": "awsui_count-number_1q84n_16ici_453",
  "icon": "awsui_icon_1q84n_16ici_492",
  "floating": "awsui_floating_1q84n_16ici_533",
  "flashbar": "awsui_flashbar_1q84n_16ici_554",
  "initial-hidden": "awsui_initial-hidden_1q84n_16ici_616",
  "flash-list": "awsui_flash-list_1q84n_16ici_219",
  "flash-focus-container": "awsui_flash-focus-container_1q84n_16ici_640",
  "flash-text": "awsui_flash-text_1q84n_16ici_670",
  "hidden": "awsui_hidden_1q84n_16ici_689",
  "header-replacement": "awsui_header-replacement_1q84n_16ici_694",
  "content-replacement": "awsui_content-replacement_1q84n_16ici_699",
  "dismiss-button": "awsui_dismiss-button_1q84n_16ici_30",
  "action-wrapped": "awsui_action-wrapped_1q84n_16ici_717",
  "action-button": "awsui_action-button_1q84n_16ici_29",
  "action-slot": "awsui_action-slot_1q84n_16ici_724",
  "flash-type-success": "awsui_flash-type-success_1q84n_16ici_728",
  "flash-type-error": "awsui_flash-type-error_1q84n_16ici_736",
  "flash-type-info": "awsui_flash-type-info_1q84n_16ici_744",
  "flash-type-in-progress": "awsui_flash-type-in-progress_1q84n_16ici_745",
  "flash-type-warning": "awsui_flash-type-warning_1q84n_16ici_754"
};
  